import {
  Component,
  OnInit,
  AfterViewInit,
  TemplateRef,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { AlertMessageService } from '../alerts/alertmsg.service';
import { ApiService } from '../services/api.service';
import { AuthData } from './auth.model';
import { CustomValidators } from '../services/CustomValidators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, AfterViewInit {
  showLoader: boolean = false;
  displayTemplate: TemplateRef<any>;
  templatedata: any;
  loginForm: FormGroup;
  forgotForm!: FormGroup;
  requestForm!: FormGroup;
  showPassword = false;
  showAccessDenied = false;
  hoveredApis: boolean = false;
  hoveredSolutions: boolean = false;
  mettingdtls: any;

  @ViewChild('selcommunication') private selcommunication: TemplateRef<any>;

  @ViewChild('showLogin') private showLogin!: TemplateRef<any>;
  @ViewChild('showForgotPswd') private showForgotPswd!: TemplateRef<any>;
  @ViewChild('showResetPwdLink') private showResetPwdLink!: TemplateRef<any>;
  @ViewChild('showTestLogin') private showTestLogin!: TemplateRef<any>;

  @ViewChild('profileName') profileNameInput: ElementRef;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private alertMsg: AlertMessageService,
    private cd: ChangeDetectorRef,
    private cv: CustomValidators,
    private apiservice: ApiService
  ) {}

  ngOnInit() {
    let host_dtls = localStorage.getItem('hostdtls');
    this.loginForm = this.fb.group({
      username: [null, Validators.required],
      projectid: [null, Validators.required],
      token: [null, Validators.required],
      callType: [null, Validators.required],
    });

    this.forgotForm = this.fb.group({
      userEmail: [
        null,
        [Validators.required, Validators.pattern(this.cv.emailRegex)],
      ],
    });

    this.requestForm = this.fb.group({
      userRequestFirstname: [
        null,
        [Validators.required, Validators.pattern(this.cv.nameRegex)],
      ],
      userRequestLastname: [
        null,
        [Validators.required, Validators.pattern(this.cv.nameRegex)],
      ],
      userRequestEmail: [
        null,
        [Validators.required, Validators.pattern(this.cv.emailRegex)],
      ],
      userRequestPhone: [null, [Validators.required]],
      userRequestCompany: [
        null,
        [Validators.required, Validators.pattern(this.cv.nameRegex)],
      ],
    });
  }

  ngAfterViewInit() {
    this.displayTemplate = this.showTestLogin;
    this.cd.detectChanges();
    setTimeout(() => {
      this.profileNameInput.nativeElement.focus();
    }, 1000);
  }

  showCommunication(action: string) {
    if (action === 'APIs') {
      this.displayTemplate = this.showLogin;
    }
  }

  goBack(action: string) {
    if (action === 'communication') {
      this.hoveredSolutions = false;
      this.displayTemplate = this.selcommunication;
    }
  }

  get loginFC() {
    return this.loginForm.controls;
  }
  get fgtFC() {
    return this.forgotForm.controls;
  }
  get reqFC() {
    return this.requestForm.controls;
  }

  forgotPassword() {
    this.displayTemplate = this.showForgotPswd;
  }
  resetPwdLink() {
    this.displayTemplate = this.showResetPwdLink;
  }
  GoToLoginFields() {
    this.displayTemplate = this.showLogin;
  }

  login(form: FormGroup) {
    if (form.invalid) {
      return;
    }
    const auth_payload = {
      email: form.value.useremail,
      password: form.value.login_password,
    };
  }

  forgotPswd(form: FormGroup) {
    if (!form.valid) {
      return;
    }
  }

  gethelp() {}

  submitLoginForm(form: FormGroup) {
    if (form.invalid) {
      return;
    }

    const payload = {
      profileId: uuidv4(),
      name: form.value.username,
      calltype: form.value.callType,
    };

    localStorage.setItem('hstname', form.value.username);

    this.apiservice
      .getMettingData(payload, form.value.projectid, form.value.token)
      .subscribe({
        next: (res: AuthData) => {
          this.mettingdtls = res;
          this.apiservice.hostdtls.next(this.mettingdtls);
          localStorage.setItem('hostdtls', JSON.stringify(this.mettingdtls));
          this.router.navigate([`/room/${this.mettingdtls.room_id}`], {
            queryParams: {
              session_id: this.mettingdtls.session_id,
              name: form.value.username,
              audioStatus:
                this.mettingdtls.call_type === 'video_call' ||
                this.mettingdtls.call_type === 'audio_call',
              videoStatus: this.mettingdtls.call_type === 'video_call',
            },
          });
        },
        error: (err) => {
          if (err.status === 401) {
            this.alertMsg.alertDanger(
              err.statusText + ',' + 'Invalid details entered'
            );
          }
        },
      });
  }
}
